import React from 'react';

import SocialBar from '../../components/SocialBar/SocialBar';
import Plan from './Plan';
import Hero from './Hero';

import './page.scss';


function HomePage() {
  return (
    <React.Fragment>
      <SocialBar />;
      <Hero />
      <Plan />
    </React.Fragment>

  );
}

export default HomePage;
